import RecordsPage from "../records/RecordsPage";

export default function MeetingReservations() {
  return <RecordsPage featureKey="meeting-reservations" />;
}
